import { Fragment } from "react";
import { Navigate } from "react-router-dom";
import App from "./App";
import Cookies from "js-cookie";


const GuardRouter = (props) => {
 //const storedToken = localStorage.getItem("token");

 const storedToken = Cookies.get("token");




  return (
    <Fragment>{storedToken ? <App></App> : <Navigate to="/auth" />}</Fragment>
  );
};

export default GuardRouter;
